import amazonProducts from './amazonProducts';
import amazonProductCategories from './amazonProductCategories';
import products from './products';
import carts from './carts';
import cartItems from './cartItems';
import customers from './customers';
import customerOrigins from './customerOrigins';
import customerFiles from './customerFiles';
import textMessages from './textMessages';
import vendors from './vendors';
import inventories from './inventories';
import inventoryCategories from './inventoryCategories';
import inventorySources from './inventorySources';
import inventoryItems from './inventoryItems';
import inventoryColumns from './inventoryColumns';
import inventoryFiles from './inventoryFiles';
import inventorySheets from './inventorySheets';
import mailMessages from './mailMessages';
import wishlistItems from './wishlistItems';
import orders from './orders';
import orderItems from './orderItems';
import siteNotifications from './siteNotifications';
import watchLists from './watchLists';
import filters from './filters';
import vendorProducts from './vendorProducts';
import vendorInventoryItems from './vendorInventoryItems';
import * as productBans from './productBans';
import refreshOperations from './refreshOperations';
import refreshTasks from './refreshTasks';
import refreshMessages from './refreshMessages';

export default {
    modules: {
        amazonProducts,
        amazonProductCategories,
        products,
        carts,
        cartItems,
        customers,
        customerOrigins,
        customerFiles,
        textMessages,
        vendors,
        inventories,
        inventoryCategories,
        inventorySources,
        inventoryItems,
        inventoryColumns,
        inventoryFiles,
        inventorySheets,
        mailMessages,
        wishlistItems,
        orders,
        orderItems,
        siteNotifications,
        watchLists,
        filters,
        vendorProducts,
        vendorInventoryItems,
        productBans,
        refreshOperations,
        refreshTasks,
        refreshMessages,
    },
    namespaced: true,
};
